import { cn } from '@/lib/utils';

/** Logo applicatif unique (public/Logo.png). */
export const APP_DEFAULT_LOGO_SRC = '/Logo.png';

type AppShellBrandProps = {
  collapsed?: boolean;
  className?: string;
  /** Panneau latéral sombre : fond blanc derrière le logo pour le contraste. */
  onDarkBackground?: boolean;
  alt?: string;
};

export function AppShellBrand({
  collapsed = false,
  onDarkBackground = false,
  alt = 'Lyrra',
  className,
}: AppShellBrandProps) {
  const logo = (
    <img
      src={APP_DEFAULT_LOGO_SRC}
      alt={alt}
      className={cn(
        'flex-shrink-0 object-contain object-left',
        collapsed ? 'h-8 max-w-[44px]' : 'h-10 max-w-[168px] w-auto',
      )}
    />
  );

  if (onDarkBackground) {
    return (
      <div
        className={cn(
          'inline-flex rounded-xl bg-white px-2 py-1.5 shadow-[0_8px_18px_rgba(0,0,0,0.25)]',
          className,
        )}
      >
        {logo}
      </div>
    );
  }

  return <div className={cn('flex min-w-0 items-center', className)}>{logo}</div>;
}
